import { useEffect, useState } from "react";
import { getDetalhesManualAtendimento } from "../../../services/SaudeBemEstar/UnimeAcolheService";
import parse from 'html-react-parser';
import './styles.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { useNavigate } from "react-router-dom";
import LoadingApp from "../../../components/LoadingApp";

function ManualUnimedAcolhe() {
    const [term, setTerm] = useState<string>('');
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 
    
    useEffect(() => {
        const getManual = async () => {
            setShowLoading(true);
            const result = await getDetalhesManualAtendimento();
            if(result !== null){
                setTerm(result.itens[0].detail);
                setShowLoading(false);
            }
        }
        getManual();
    }, []);

    const goBack = () => {
        navigate('/saudeBemEstar/unimedAcolhe/inicio');
    }

    return (
        <div className={accessibility.contrastMode ? 'contrast-mode-unimed-acolhe-manual-holder' : 'unimed-acolhe-manual-holder' } style={accessibility.textStyleAccessibility}>
            <LoadingApp showLoading={showLoading} />
            {parse(term)}
            <button className="back-button" style={accessibility.textStyleAccessibility} onClick={goBack}>
                <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
            </button>
        </div>
    )
}

export default ManualUnimedAcolhe;

